import type { ListShipment } from '@fv/client-types'

import { ShipperSlider } from '@/components/ShipperSlider'

import { ChargeForm } from './ChargeForm'
import type { ChargeListState } from './types'

export const ChargesSlider = ({
  chargeState,
  load,
}: {
  chargeState: ChargeListState
  load: ListShipment
}) => {
  const { quote, isEditing, setIsEditing } = chargeState

  return (
    <ShipperSlider
      className="flex flex-col"
      isOpen={isEditing}
      onClose={() => setIsEditing(false)}
    >
      {!!quote && (
        <ChargeForm
          chargeState={chargeState}
          load={load}
          onCancel={() => setIsEditing(false)}
        />
      )}
    </ShipperSlider>
  )
}
